import {gql} from "@apollo/client";
import {OrderType} from "../../../../../graphql/types/OrderType";
import {OrderFiltersType} from "../../../../../graphql/types/OrderFiltersType";
import { ORDER_FIELDS } from "../../../parcels/graphql/queries/getOrderListingForCentral";


export const GET_ORDER_LISTING_FOR_CENTRAL = gql`
    query CentralQuery($filters: OrderFiltersTypeInput,
                         $pageRequest: PageRequestTypeInput) {
        getOrderListingForCentral: getOrderListingForCustomerServiceExceptions(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${ORDER_FIELDS}
                recipientAddress {
                    id
                    fullName
                    countryCode
                    phoneNumber
                    addressLine1
                    addressLine2
                    city
                    state
                    zipcode
                    company
                    instructions
                }
            }
            page
            size
            totalElements
            totalPages
            accessiblePages
            hasNext
            hasPrevious
        }
    }
`;

export interface CentralOrderListResponse {
    getOrderListingForCentral: OrderListingResponseType;
}

export interface OrderListingResponseType {
    content: OrderType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    accessiblePages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface GetOrderListingForCentralInput {
    filters?: OrderFiltersType;
    pageRequest?: PageRequestType;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}